import { render, staticRenderFns } from "./ReservationsPayment.vue?vue&type=template&id=67dd5786&"
import script from "./ReservationsPayment.vue?vue&type=script&lang=js&"
export * from "./ReservationsPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports